import { SnackbarGlobalConfig } from '@bbraun/cortex/snackbar';

export const CUSTOM_SNACKBAR_CONFIG: SnackbarGlobalConfig = {
  closeButton: true
};
